import axios, { AxiosProgressEvent } from "axios";
import redux from "../redux/redux";


export type ServerResponse<T> = {
  Success: boolean;
  LoginRequired: boolean;
  Message: string;
  GoTo:string;
  Value: T;
};

export class ServerCallOptions {
  loadingScreenShow: boolean = true;
  loadingScreenText: string = "loading";
}

export class Server {
  loadingScreen: boolean;
  isDev: boolean = false;

  static queryStringAddParam: any = null;

  constructor(loadingScreen: any) {
    this.loadingScreen = loadingScreen;

    this.isDev = window.location.host.indexOf("localhost:") > -1;
    let params = new URLSearchParams(window.location.search);
    let fairId = params.get("f");
    if (fairId) {
      Server.queryStringAddParam = `f=${fairId}`;
    }
  }

  

  public async getApi2<T>(url: string): Promise<ServerResponse<T>> {
    if (this.loadingScreen) {
      redux.loading(true);
    }
    
    return await axios
      .get(this.makeUrl2(url),{headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      }})
      .then((x: any) => {
        if (this.loadingScreen) {
          redux.loading(false);
        }
        return x.data;
      })
      .catch((x: any) => {
        if (this.loadingScreen) {
          redux.loading(false);          
        }
        console.log(x);
        return {
          Success: false,
          LoginRequired: false,
          Message: x.message ?? "An unknown request error occurred.",
          GoTo: "",
          Value: null,
        } as ServerResponse<T>;
      });
  }

  public async getApi2Quite<T>(url: string): Promise<ServerResponse<T>> {
    return await axios
      .get(this.makeUrl2(url),{headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      }})
      .then((x: any) => {
        if (this.loadingScreen) {
        }
        return x.data;
      })
      .catch((x: any) => {
        if (this.loadingScreen) {
        }
        console.log(x);
        return {
          Success: false,
          LoginRequired: false,
          Message: x.message ?? "An unknown request error occurred.",
          GoTo: "",
          Value: null,
        } as ServerResponse<T>;
      });
  }

  public async getApi<T>(url: string): Promise<T> {
    if (this.loadingScreen) {
      redux.loading(true);
    }

    return await axios
      .get(this.makeUrl(url),{headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      }})
      .then((x: any) => {
        if (this.loadingScreen) {
          redux.loading(false);
        }
        return x.data;
      })
      .catch((x: any) => {
        if (this.loadingScreen) {
          redux.loading(false);
        }
        console.log(x);
        return {
          Success: false,
          LoginRequired: false,
          Message: x.message ?? "An unknown request error occurred.",
          GoTo: "",
          Value: null,
        } as ServerResponse<T>;
      });
  }

  
  public async getApiQuiet<T>(url: string): Promise<T> {
    return await axios
      .get(this.makeUrl(url),{headers: {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0',
    }})
      .then((x: any) => {
        return x.data;
      })
      .catch((x: any) => {
        console.log(x);
        return {
          Success: false,
          LoginRequired: false,
          Message: x.message ?? "An unknown request error occurred.",
          GoTo: "",
          Value: null,
        } as ServerResponse<T>;
      });
  };

  public async postApi2<T>(url: string, data: any, filesArray: File[] = []): Promise<ServerResponse<T>> {
    if (this.loadingScreen) {
      redux.loading(true);
    }
    if (filesArray.length) {
      return await this.postWithFiles<ServerResponse<T>>(data, filesArray, url)
      .then((x) => {
        if (this.loadingScreen) {
          redux.loading(false);
        }
        return x;
      })
      .catch((x) => {
        if (this.loadingScreen) {
          redux.loading(false);
        }
        console.log(x);
        return {
          Success: false,
          LoginRequired: false,
          Message: (x.message || x.Message || x.error || x.toString())  ?? "An unknown request error occurred.",
          GoTo: "",
          Value: null,
        } as ServerResponse<T>;
      });
    } else {
      return await this.postNoFiles<ServerResponse<T>>(url, data)
      .then((x) => {
        if (this.loadingScreen) {
          redux.loading(false);
        }
        return x;
      })
      .catch((x) => {
        if (this.loadingScreen) {
          redux.loading(false);
        }
        console.log(x);
        return {
          Success: false,
          LoginRequired: false,
          Message: (x.message || x.Message || x.error || x.toString())  ?? "An unknown request error occurred.",
          GoTo: "",
          Value: null,
        } as ServerResponse<T>;
      });

    }
  }

  public async postApi<T>(url: string, data: any, filesArray: File[] = []): Promise<T> {
    if (this.loadingScreen) {
      redux.loading(true);
    }
    if (filesArray.length) {
      return await this.postWithFiles<T>(data, filesArray, url);
    } else {
      return await this.postNoFiles<T>(url, data);

    }
  }

  private async postWithFiles<T>(data: any, filesArray: File[], url: string) {
    //TODO:  This needs to be tested.  Not sure if it will work.  Do we need to set content type for each item in the multi part form data?
    const formData = new FormData();
    Object.entries<any>(data).forEach((entry) => {
      formData.append(entry[0], JSON.stringify(entry[1]));
    });
    
  
    filesArray.forEach(f => {
      formData.append('file', f, f.name);
    });
    
    console.log(formData);

    let result = await axios.post<T>(this.makeUrl(url), formData, { //Do we even need to set headers?
      headers:{"Content-Type": "multipart/form-data"},
      onUploadProgress:(event:AxiosProgressEvent)=> {
        redux.uploadProgress(event);
        // let precent = event.loaded / event.total * 100.0;
        // console.log(precent);
        //   console.log(`${event.loaded} of ${event.total}`);
      },
    });
    
    if (this.loadingScreen) {
      redux.loading(false);
    }
    return result.data;
  }

  private async postNoFiles<T>(url: string, data: any) {
    let result = await axios
      .post<T>(this.makeUrl(url), data, {
        headers: { "Content-Type": "application/json; charset=utf-8" },
      })
      .catch((x) => {
        if (this.loadingScreen) {
          redux.loading(false);
        }
        console.log(x);
        throw x;
      });
    if (this.loadingScreen) {
      redux.loading(false);
    }
    return result.data;
  }

  
  /** POST that may return a file (blob) or ResponseModel JSON (errors). */
  public async postApiDownload(url: string, data: any, fallbackFileName: string): Promise<ServerResponse<boolean>> {
    if (this.loadingScreen) {
      redux.loading(true);
    }
    try {
      const result = await axios.post(this.makeUrl(url), data, {
        headers: { "Content-Type": "application/json; charset=utf-8" },
        responseType: "blob",
      });
      const contentType = String(result.headers["content-type"] || "").toLowerCase();
      const blob: Blob = result.data instanceof Blob
        ? result.data
        : new Blob([result.data], { type: contentType || "application/octet-stream" });
      if (contentType.indexOf("json") >= 0) {
        const text = await blob.text();
        try {
          return JSON.parse(text) as ServerResponse<boolean>;
        } catch {
          return {
            Success: false,
            LoginRequired: false,
            Message: text || "Could not download the file.",
            GoTo: "",
            Value: null,
          };
        }
      }
      const header = String(result.headers["content-disposition"] || "");
      const star = /filename\*=(?:UTF-8''|utf-8'')([^;]+)/i.exec(header);
      const plain = /filename="?([^";]+)"?/i.exec(header);
      let fileName = fallbackFileName;
      if (star && star[1]) fileName = decodeURIComponent(star[1].trim());
      else if (plain && plain[1]) fileName = plain[1].trim();
      const objectUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(objectUrl);
      return {
        Success: true,
        LoginRequired: false,
        Message: "",
        GoTo: "",
        Value: true,
      };
    } catch (x: any) {
      const blob = x && x.response && x.response.data;
      if (blob && typeof blob.text === "function") {
        try {
          const parsed = JSON.parse(await blob.text());
          if (parsed && typeof parsed.Success === "boolean") return parsed as ServerResponse<boolean>;
        } catch {
        }
      }
      return {
        Success: false,
        LoginRequired: false,
        Message: (x && (x.message || x.Message)) || "Could not download the file.",
        GoTo: "",
        Value: null,
      };
    } finally {
      if (this.loadingScreen) {
        redux.loading(false);
      }
    }
  }

  public async postApiQuite<T>(url: string, data: any, filesArray: File[] = []): Promise<T> {
    if(filesArray && filesArray.length){
      let result = await this.postWithFiles<T>(data, filesArray, url);
      return result;
    }
    let result = await axios
      .post<T>(this.makeUrl(url), data, {
        headers: { "Content-Type": "application/json; charset=utf-8" },
      })
      .catch((x) => {
        console.log(x);
        throw x;
      });
    return result.data;
  }
  /**This overvariation of postApi handles server response errors.  If serverResponse.Success === false, it will throw an error. */
  public async postApiWithServerResponse<T>(url: string, data: any, filesArray: File[] = []): Promise<ServerResponse<T>> {
    let response = await this.postApi<ServerResponse<T>>(url, data, filesArray).catch(error => { throw (error); });
    if (!response.Success) {
      throw response.Message;
    }
    return response;
  }


  clearLoading() {
    redux.loading(false);
  }

  public static GetDevHost(){
    
    let params = new URLSearchParams(window.location.search);
    const host = params.get('host') ?? 'http://localhost:8081';
    return host;
  }

  public makeUrl(url: string): string {
    url = url.trim();
    if(url.toLocaleLowerCase().indexOf('http') === 0) return url;
    
    if (url.indexOf("/") === 0 || url.indexOf("\\") === 0) {
      url = url.substr(1);
    }

    url = `${window.location.origin}/${url}`;
    if (Server.queryStringAddParam) {
      if (url.indexOf("?") > -1) {
        url += `&${Server.queryStringAddParam}`;
      } else {
        url += `?${Server.queryStringAddParam}`;
      }
    }

    return url;
  }

  public makeUrl2(url: string): string {
    url = url.trim();
    if(url.startsWith('../')) url = url.substring(2);

    return url;
  }
}
